import * as Sentry from '@sentry/browser'
import { CaptureConsole as CaptureConsoleIntegration } from '@sentry/integrations'
import { production } from './core/core.env'

Sentry.init({
  dsn: 'https://ddc4bdfe86f44a2da42a2ade200e375a@o490003.ingest.sentry.io/5589791',
  enabled: true,
  environment: production ? 'production' : 'staging',
  release: process.env.CODEBUILD_BUILD_NUMBER,
  integrations: [new CaptureConsoleIntegration(
    {
      levels: ['error', 'debug']
    }
  )],
  disablePerformance: true,
  include: '../../../../assets'
})
